import { BrowserRouter } from "react-router-dom";
import CompScrollTop from "./component/CompScrollTop";
import Heliosen from "./component/Heliosen";

function App() {
  return (
    <BrowserRouter>
      <CompScrollTop />
      <Heliosen />
    </BrowserRouter>
  );
}

export default App;
